module.exports = __webpack_public_path__ + "static/media/Baloo-Regular.4a2f0b51.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Baloo/Baloo-Regular.ttf
// module id = 293
// module chunks = 0